<div class="account__menu">
  <div>
    <a
      routerLink="/account"
      routerLinkActive="selected"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <img
        [src]="
          isActive('/account')
            ? 'assets/icon-dashboard-green.svg'
            : 'assets/icon-dashboard.svg'
        "
        width="110"
        height="104"
        alt="Dashboard icon"
      />
      <span>Dashboard</span>
    </a>
    <a routerLink="downloads" routerLinkActive="selected">
      <img
        src="assets/icon-download.svg"
        width="110"
        height="104"
        alt="Download icon"
      />
      <span>Downloads</span>
    </a>
    <a routerLink="dreambox" routerLinkActive="selected">
      <img
        [src]="
          isActive('/account/dreambox')
            ? 'assets/icon-heart-red.svg'
            : 'assets/icon-heart.svg'
        "
        width="110"
        height="104"
        [alt]="
          isActive('/account/dreambox') ? 'Your favorite' : 'Add to favorites'
        "
      />
      <span>Dreambox</span>
    </a>
  </div>
  <div>
    <a routerLink="invoices" routerLinkActive="selected">
      <img
        src="assets/icon-invoice.svg"
        width="110"
        height="104"
        alt="Invoices icon"
      />
      <span>Invoices</span>
    </a>
    <a routerLink="profile" routerLinkActive="selected">
      <img
        src="assets/icon-user.svg"
        width="110"
        height="104"
        alt="User profile icon"
      />
      <span>Profile</span>
    </a>
  </div>
</div>
